
define('hbs!app/filters/FiltersView.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "	<span id=\"error-invalid-filters\" class=\"alert alert-danger\" role=\"alert\">Each filter must have a valid value.</span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"report-filters-container\"></div>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isViewOnly : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});Handlebars.registerPartial('app/filters/FiltersView.hbs', t);return t;});
